import buildspace from '../Assets/brands/buildspace.svg';
import ethglobal from '../Assets/brands/ethglobal.svg';
import google from '../Assets/brands/google.svg';
import linkedin from '../Assets/brands/linkedin.svg'
import pluralsight from '../Assets/brands/pluralsight.svg'
import testdome from '../Assets/brands/testdome.svg'
import udemy from '../Assets/brands/udemy.svg'

import books from '../Assets/brands/books.svg'
import calendar from '../Assets/brands/calendar.svg'



export const CertificationsList = [{
		brandName: "LinkedIn Learning",
		brandLogo: linkedin,
		brandLocation: "Software Architecture: Patterns for Developers - 2023",
		link: 'https://www.linkedin.com/learning/certificates/bb7944db075f9c4a6095d2d8509f1d873a9090251ee2fba1b6d3caa4c6a6c5b2'
	},
	{
		brandName: "ETHGlobal",
		brandLogo: ethglobal,
		brandLocation: 'ETHOnline 2022 Staked Hacker - 2022',
		link: 'https://app.poap.xyz/token/5793811'

	},
	{
		brandName: "ETHGlobal",
		brandLocation: "Metabolism Staked Hacker - 2022",
		brandLogo: ethglobal,
		link: 'https://app.poap.xyz/token/5518041'
	},
	{
		brandName: "Udemy",
		brandLocation: "Data Structures and Algorithms - 2022",
		brandLogo: udemy,
		link: 'https://www.udemy.com/certificate/UC-a99f222e-c308-458a-8e0d-6d49abb28f3f/'
	},
	{
		brandName: "ETHGlobal",
		brandLocation: "HackMoney 2022 Staked Hacker - 2022",
		brandLogo: ethglobal,
		link: 'https://app.poap.xyz/token/5120639'
	},
	{
		brandName: "Buildspace",
		brandLocation: "Build a Web3 App: Mint Your Own NFT collection - Buildspace NFT - 2022",
		brandLogo: buildspace,
		link: 'https://opensea.io/assets/matic/0x3CD266509D127d0Eac42f4474F57D0526804b44e/15041?force_update=true'
	},
	{
		brandName: "Buildspace",
		brandLocation: "Create a NFT game - Buildspace NFT - 2022",
		brandLogo: buildspace,
		link: 'https://opensea.io/assets/matic/0x3CD266509D127d0Eac42f4474F57D0526804b44e/15957?force_update=true'
	},
	{
		brandName: "Pluralsight",
		brandLocation: "Building web applications with React - 2020",
		brandLogo: pluralsight,
		link: 'https://drive.google.com/file/d/122QpdgfxnUDPJh10XoQvStcLzQxHTbdm/view'
	},
	{
		brandName: "TestDome",
		brandLocation: "HTML/CSS (Top 25% worldwide) - 2020",
		brandLogo: testdome,
		link: 'https://www.testdome.com/certificates/30a37f7b023c44e5b2259901013c2187'
	},
	{
		brandName: "Pluralsight",
		brandLocation: "HTML5 - 2019",
		brandLogo: pluralsight,
		link: 'https://drive.google.com/file/d/126gKMi4CmascIo5Iup4-n6Q9jbs5uUwr/view'
	},
	{
		brandName: "Pluralsight",
		brandLocation: "JavaScript - 2019",
		brandLogo: pluralsight,
		link: 'https://drive.google.com/file/d/12865bIqCpHUZQCvF6Nh23II0ML0RINhm/view'
	},
	{
		brandName: "Google. Andela. Pluralsight",
		brandLocation: "Pluralsight Associate Android Developer (AAD) IQ - 2018",
		brandLogo: google,
		link: 'https://drive.google.com/file/d/0B5ZR-zhvXwv2MjZwRVlIbktkTEJZWmxrSUk1b29lVm8zZmhF/view?resourcekey=0-GNSD-xZr7fKOR3nX5brCBw'
	},
	{
		brandName: "Google. Andela. Udacity",
		brandLocation: "Google Africa Scholarships. Android Basics Course - 2018",
		brandLogo: google,
		link: 'https://drive.google.com/file/d/1Em1Yk51DMaxgeEkd2w4n4TE78SpADH-W/view'
	},
]

export const AchievementsList = [{
		brandName: "170+ books read in three years",
		brandLogo: books
	},

	// {
	// 	brandName: "No missed deadlines in 365+ days",
	// 	brandLogo: calendar
	// },
]